import React, { FC } from 'react';
// import SubscriptionPlan from './SubscriptionPlan';
import './SubscriptionPlanPage.scss';
// import HomePlans from '../Home/HomePlans';
import Footer from '../Home/Footer';
// import '../Home/Home.scss';
import SubscriptionPlan from './SubscriptionPlan';

const SubscriptionPlanPage: FC = () => (
	<div className="home-wrapper" style={{ marginTop: '30px' }}>
		{/* <SubscriptionPlan /> */}
		{/* <HomePlans /> */}
		<SubscriptionPlan />
		<Footer />
	</div>
);

export default SubscriptionPlanPage;
